export default __webpack_public_path__ + "static/media/mode-28.6e481a68.svg";